import { MapLayer, MapWorkspace } from '@trimble/geospatial';

export interface WorkspaceLayerFilterLogger {
  error(message: string, context?: Record<string, unknown>): void;
}

/**
 * Drops workspace layer references left dangling by a layer that failed to
 * load (e.g. skipped upstream for malformed Maps API data) instead of letting
 * the UI render an unselectable "ghost" layer node for it.
 */
export function filterLoadedWorkspaceLayers(
  workspaces: readonly MapWorkspace[],
  layers: readonly MapLayer[],
  logger: WorkspaceLayerFilterLogger
): MapWorkspace[] {
  const loadedLayerIds = new Set(layers.map((layer) => layer.id));
  return workspaces.map((workspace) => {
    const validLayerIds = workspace.layerIds.filter((layerId) => {
      if (loadedLayerIds.has(layerId)) {
        return true;
      }
      logger.error('Skipping faulty workspace layer reference', {
        workspaceId: workspace.id,
        layerId,
      });
      return false;
    });
    return validLayerIds.length === workspace.layerIds.length
      ? workspace
      : { ...workspace, layerIds: validLayerIds };
  });
}
